import { queries } from 'src/config/queries';
import { queryClient } from 'src/config/request';
const invalidateProductQueries = () => {
    queryClient.removeQueries({
        queryKey: [...queries.product.freeSignupStatus._def]
    });
    queryClient.removeQueries({
        queryKey: [...queries.product.offer._def]
    });
};
export default invalidateProductQueries;
